import React from 'react';
import UploadMultiDocuments from '@components/UploadMultiDocuments';
import { FileListData } from '@typings/ResidentTypes';
import UploadedFileTable from '@components/UploadedFileTable';
import '../../../styles.scss';

interface UploadAssessmentFormProps {
  userId: string;
  uploadedMcaFormList: FileListData[];
  setUploadedMcaFormList: React.Dispatch<React.SetStateAction<FileListData[]>>;
}

const UploadAssessmentForm: React.FC<UploadAssessmentFormProps> = ({
  userId,
  uploadedMcaFormList,
  setUploadedMcaFormList,
}) => {
  return (
    <div className="govuk-form-group mt-10 govuk-bp:mt-14">
      <h3 className="govuk-label-wrapper">
        <label
          className="govuk-label govuk-label--s"
          htmlFor="upload-assessment"
        >
          Upload a copy of the mental capacity assessment form(s)
        </label>
      </h3>
      <div id="upload-assessment" className="govuk-hint">
        Upload a copy of the person&apos;s mental capacity assessment form(s)
      </div>
      <UploadMultiDocuments
        userId={userId}
        fileList={uploadedMcaFormList}
        setFileList={setUploadedMcaFormList}
        uploadInputId="upload-mca-form"
        customizedButtonText="Upload form"
      />
      <div className="mt-10 govuk-bp:mt-14">
        {uploadedMcaFormList.length > 0 && (
          <UploadedFileTable
            fileList={uploadedMcaFormList}
            setFileList={setUploadedMcaFormList}
          />
        )}
      </div>
    </div>
  );
};

export default UploadAssessmentForm;
